import { render, staticRenderFns } from "./OilMainDetails.vue?vue&type=template&id=a117f02e&"
import script from "./OilMainDetails.vue?vue&type=script&lang=js&"
export * from "./OilMainDetails.vue?vue&type=script&lang=js&"
import style0 from "./OilMainDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports